import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [stats, setStats] = useState({ properties: 0, satisfaction: 0, experience: 0 });

  const slides = [
    {
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&h=1080&fit=crop',
      alt: 'Modern Luxury Villa'
    },
    {
      image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&h=1080&fit=crop',
      alt: 'Urban Penthouse'
    },
    {
      image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1920&h=1080&fit=crop',
      alt: 'Family Mansion'
    }
  ];

  // Auto-advance slides
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Animate stats
  useEffect(() => {
    const animateStats = () => {
      const targets = { properties: 250, satisfaction: 98, experience: 15 };
      const duration = 2500;
      const steps = 60;
      const stepTime = duration / steps;

      let step = 0;
      const interval = setInterval(() => {
        step++;
        const progress = step / steps;
        
        setStats({
          properties: Math.floor(targets.properties * progress),
          satisfaction: Math.floor(targets.satisfaction * progress),
          experience: Math.floor(targets.experience * progress)
        });

        if (step >= steps) {
          clearInterval(interval);
          setStats(targets);
        }
      }, stepTime);
    };

    const timer = setTimeout(animateStats, 1500);
    return () => clearTimeout(timer);
  }, []);

  const scrollToProperties = () => {
    document.getElementById('properties')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero-luxhom" role="banner" aria-label="Hero section">
      <div className="container">
        <article 
          className="hero-content-luxhom"
        >
          <div 
            className="hero-badge-luxhom"
          >
            <span>LUXURY LIVING REDEFINED</span>
          </div>

          <h1 
            className="hero-title-luxhom"
          >
            Discover Your Dream Property Across India
          </h1>

          <p 
            className="hero-subtitle-luxhom"
          >
            Experience unparalleled luxury across Karnataka, Goa, Andhra Pradesh, Tamil Nadu, Pune, and Mumbai. 
            Your perfect property awaits with our exclusive collection of BDA approved plots, BRMDA sites, and premium real estate.
          </p>

          <nav 
            className="hero-buttons-luxhom"
            aria-label="Hero navigation"
          >
            <button className="btn-luxhom" onClick={scrollToProperties} aria-label="Explore available properties">
              <span>Explore Properties</span>
              <i className="fas fa-arrow-right" aria-hidden="true"></i>
            </button>
            <button className="btn-luxhom-contact" onClick={scrollToContact} aria-label="Contact TrueHome Properties">
              <i className="fas fa-phone" aria-hidden="true"></i>
              <span>Contact Us</span>
            </button>
          </nav>
        </article>
      </div>

      <a 
        href="#properties" 
        className="hero-scroll-luxhom"
        onClick={(e) => {
          e.preventDefault();
          scrollToProperties();
        }}
        aria-label="Scroll down to explore properties"
      >
        <span>Scroll to Explore</span>
      </a>
    </section>
  );
};

export default Hero;